import { Model } from "vuex-fetch-factory";

export interface InvoiceRaw {
  relation_id: number;
  invoice_id: number;
  invoice_description: string;
  invoice_date: string;
  amount_excl_vat: number;
  amount_incl_vat: number;
}

export class InvoiceModel implements Model<InvoiceModel, InvoiceRaw> {
  public relation_id = 0;
  public invoice_id = 0;
  public invoice_description = "";
  public invoice_date = "";
  public amount_excl_vat = 0;
  public amount_incl_vat = 0;

  public getNew(): InvoiceModel {
    return new InvoiceModel();
  }

  public fillModel(raw: InvoiceRaw): this {
    this.relation_id = raw.relation_id;
    this.invoice_id = raw.invoice_id;
    this.invoice_description = raw.invoice_description;
    this.invoice_date = raw.invoice_date;
    this.amount_excl_vat = raw.amount_excl_vat;
    this.amount_incl_vat = raw.amount_incl_vat;
    return this;
  }

  public getRaw(): InvoiceRaw {
    return {
      relation_id: this.relation_id,
      invoice_id: this.invoice_id,
      invoice_description: this.invoice_description,
      invoice_date: this.invoice_date,
      amount_excl_vat: this.amount_excl_vat,
      amount_incl_vat: this.amount_incl_vat
    };
  }

  public get url(): string {
    return `api/invoices/${this.invoice_id}/pdf/Factuur ${this.invoice_id}.pdf`;
  }
}
